import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Stack,
  alpha,
  useTheme,
  Avatar,
  Rating,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  Search as SearchIcon,
  CheckCircle as CheckCircleIcon,
  Schedule as ScheduleIcon,
  Backup as BackupIcon,
  CleaningServices as CleaningIcon,
  Speed as SpeedIcon,
} from "@mui/icons-material";
import SupportLayout from "../Support/SupportLayout";

const FindCleaners = () => {
  const theme = useTheme();

  const benefits = [
    { icon: <SearchIcon />, title: "Browse Trusted Cleaners", desc: "View profiles, ratings, and availability of local professionals" },
    { icon: <ScheduleIcon />, title: "Flexible Booking", desc: "Book one-time or recurring cleanings based on your needs" },
    { icon: <BackupIcon />, title: "Backup Coverage", desc: "Get replacement cleaners instantly when your regular cleaner isn't available" },
    { icon: <CleaningIcon />, title: "Guest-Ready Properties", desc: "Ensure every turnover meets your quality standards" },
    { icon: <SpeedIcon />, title: "Save Time", desc: "Stop manually searching and vetting cleaners" },
  ];

  const stats = [
    { value: "500+", label: "Trusted Cleaners" },
    { value: "4.9★", label: "Average Rating" },
    { value: "2,500+", label: "Jobs Completed/Month" },
    { value: "24hr", label: "Average Response" },
  ];

  return (
    <SupportLayout
      title="Find Trusted Cleaners for Every Turnover"
      category="Services"
      subtitle="Connect with reliable cleaners for Airbnb turnovers, same-day cleanings, deep cleans, and recurring property needs."
      breadcrumbs={[
        { label: "Services", link: "/services" },
        { label: "Find a Cleaner" },
      ]}
    >
      {/* Benefits Grid */}
      <Grid container spacing={4} sx={{ mb: 6 }}>
        {benefits.map((benefit, idx) => (
          <Grid item xs={12} md={4} key={idx}>
            <Card sx={{ height: "100%", p: 3, borderRadius: 3 }}>
              <Box sx={{ color: theme.palette.primary.main, mb: 2 }}>
                {React.cloneElement(benefit.icon, { sx: { fontSize: 40 } })}
              </Box>
              <Typography variant="h6" fontWeight="700" gutterBottom>
                {benefit.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {benefit.desc}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Stats */}
      <Grid container spacing={3} sx={{ mb: 6 }}>
        {stats.map((stat, idx) => (
          <Grid item xs={6} md={3} key={idx}>
            <Card sx={{ textAlign: "center", p: 3 }}>
              <Typography variant="h4" fontWeight="800" color="primary.main">
                {stat.value}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {stat.label}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* CTA */}
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Button
          variant="contained"
          size="large"
          startIcon={<SearchIcon />}
          sx={{ borderRadius: "50px", px: 5, py: 1.5 }}
        >
          Find a Cleaner Now
        </Button>
      </Box>
    </SupportLayout>
  );
};

export default FindCleaners;